import React from "react";
var __jsx = React.createElement;
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import Markdown from "markdown-to-jsx";
export default function WarrantyOptionItem(_ref) {
  var _item$price, _item$price2, _item$price3, _item$price$current, _item$price4, _item$price$original_, _item$price5, _item$price6, _item$badge$backgroun, _item$badge, _item$badge$backgroun2;
  var item = _ref.item,
    isSelected = _ref.isSelected,
    onSelect = _ref.onSelect,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "sm" : _ref$size,
    _ref$showBadge = _ref.showBadge,
    showBadge = _ref$showBadge === void 0 ? true : _ref$showBadge,
    _ref$animateGlow = _ref.animateGlow,
    animateGlow = _ref$animateGlow === void 0 ? false : _ref$animateGlow;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  var isFree = ((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.is_free) || ((_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : _item$price2.current) === 0;
  var padding = "px-3 py-3";
  var hasBadge = Boolean(item.badge) && showBadge;
  var currentFormatted = ((_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : _item$price3.current_formatted) || String((_item$price$current = (_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.current) !== null && _item$price$current !== void 0 ? _item$price$current : "");
  var originalFormatted = (_item$price$original_ = (_item$price5 = item.price) === null || _item$price5 === void 0 ? void 0 : _item$price5.original_formatted) !== null && _item$price$original_ !== void 0 ? _item$price$original_ : "";
  var freeText = ((_item$price6 = item.price) === null || _item$price6 === void 0 ? void 0 : _item$price6.current_formatted) || tShort("warranty/free", {
    ns: "web_checkout_cash"
  });

  // Glow color derived from badge background, fallback to purple
  var glowColor = (_item$badge$backgroun = (_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.background_color) !== null && _item$badge$backgroun !== void 0 ? _item$badge$backgroun : "#8E47E0";
  return /*#__PURE__*/React.createElement(motion.div, {
    onClick: function onClick() {
      return onSelect(item.id);
    },
    layout: true,
    whileTap: {
      scale: 0.98
    },
    animate: animateGlow && !isSelected ? {
      // Pulsing glow on the recommended option when NOT selected
      boxShadow: ["0 0 0 1.5px ".concat(glowColor, "40, 0 0 0px 0px ").concat(glowColor, "00"), "0 0 0 2px ".concat(glowColor, "CC, 0 0 12px 2px ").concat(glowColor, "55"), "0 0 0 1.5px ".concat(glowColor, "40, 0 0 0px 0px ").concat(glowColor, "00")]
    } : isSelected ? {
      boxShadow: "0 0 0 2px #0d0db3, 0 0 0px 0px #0d0db300"
    } : {
      boxShadow: "0 0 0 1px #d6dfe9"
    },
    transition: animateGlow && !isSelected ? {
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    } : {
      duration: 0.2
    },
    className: twMerge("w-full ".concat(padding, " rounded-lg cursor-pointer min-h-[60px] transition-colors relative"), hasBadge && "mt-[18px] md:mt-[6px]", isSelected ? "bg-[#e7e7f8]" : "bg-white hover:bg-[#f5f5ff]")
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, hasBadge && /*#__PURE__*/React.createElement(motion.div, {
    initial: {
      scale: 0.8,
      opacity: 0
    },
    animate: {
      scale: 1,
      opacity: 1
    },
    exit: {
      scale: 0.8,
      opacity: 0
    },
    className: "flex items-center gap-1 px-2 py-0.5 rounded-[3px] absolute top-[-10px] inset-x-0 mx-auto w-fit",
    style: {
      backgroundColor: (_item$badge$backgroun2 = item.badge.background_color) !== null && _item$badge$backgroun2 !== void 0 ? _item$badge$backgroun2 : "#8E47E0"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: item.badge.icon,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-medium text-sm leading-[17px] whitespace-nowrap",
    style: {
      color: item.badge.color
    }
  }, item.badge.text))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between w-full gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start text-right flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1.5 flex-row-reverse w-full justify-end"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: item.title,
    options: {
      forceInline: true
    },
    className: ["font-medium leading-snug text-[clamp(12px,1.8vw,13px)] [&_strong]:font-bold", isSelected ? "text-[#0d0db3]" : "text-[#00143c]"].join(" ")
  }, item.title)), item.subtitle ? /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-[#6d7a8d] leading-5 text-start w-full text-[clamp(10px,1.5vw,11px)]"
  }, item.subtitle) : null), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 flex-shrink-0 flex-row-reverse"
  }, isFree ? /*#__PURE__*/React.createElement(Markdown, {
    key: freeText,
    options: {
      forceInline: true
    },
    className: "font-medium text-[#6b7ea5] text-[12px]"
  }, freeText) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: currentFormatted,
    options: {
      forceInline: true
    },
    className: "font-medium text-[#00143c] leading-tight text-[clamp(14px,2vw,15px)] [&_strong]:font-bold"
  }, currentFormatted)), !!originalFormatted && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5 opacity-70"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6d7a8d] leading-tight text-[clamp(11px,1.8vw,12px)]"
  }, /*#__PURE__*/React.createElement(Markdown, {
    key: originalFormatted,
    className: "strike-adjust-wrap"
  }, originalFormatted)))))));
}